import React from 'react';
import { Chip } from '@mui/material';

const MAP = {
  queued: { label: 'Queued', color: 'default' },
  running: { label: 'Running', color: 'primary' },
  completed: { label: 'Completed', color: 'success' },
  stopped: { label: 'Stopped early', color: 'warning' },
  failed: { label: 'Failed', color: 'error' },
  pending: { label: 'Waiting for you', color: 'warning' },
  approved: { label: 'Approved', color: 'primary' },
  executed: { label: 'Done (dry run)', color: 'success' },
  rejected: { label: 'Rejected', color: 'default' },
  expired: { label: 'Expired', color: 'default' },
  active: { label: 'Connected', color: 'success' },
  invalid: { label: 'Needs attention', color: 'error' },
  revoked: { label: 'Removed', color: 'default' },
};

export default function StatusChip({ status, size = 'small' }) {
  const entry = MAP[status] || { label: status, color: 'default' };
  return <Chip size={size} label={entry.label} color={entry.color} variant={entry.color === 'default' ? 'outlined' : 'filled'} />;
}

export function DryRunChip() {
  return (
    <Chip
      size="small"
      color="warning"
      variant="outlined"
      label="Dry run: no email is sent"
    />
  );
}
